import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../../reducer/CombineReducer";
import { SchedulingModes } from "../CreateSchedule/redux/Types";
import { ScheduleInstanceTableView } from "./ScheduleInstanceTable.view";

// Responsible for rendering scgedule instance table
export const ScheduleInstanceTable: React.FC = () => {
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const scheduleInstances = scheduling.scheduleInstances;
  const isViewMode = scheduling.mode === SchedulingModes.VIEW;

  return (
    <>
      {isViewMode && scheduleInstances.length > 0 &&
        <ScheduleInstanceTableView tableData={scheduleInstances} />
      }
    </>
  );
};
